module.exports = __webpack_public_path__ + "img/ballot_animate.2b0aa64c.gif";